import React, { useEffect, useRef } from "react";
import ui_img from "@/images/ui.png";
import ux_img from "@/images/ux.png";
import Ui_d_img from "@/images/Ui_d.png";
import frontend_dev_img from "@/images/Frontend_dev.png";
import { useIsMobile } from "@/hooks/use-mobile";

const features = [
//   {
//     title: "UI Design",
//     content: "Creating beautiful and intuitive user interfaces Creating beautiful and intuitive user interfaces",
//     bg: "bg-white",
//     img: ui_img,
//   },
  {
    title: "UX Design",
    content: "Crafting seamless user experiences Creating beautiful and intuitive user interfaces",
    bg: "bg-white",
    img: ux_img
  },
  {
    title: "UI Design",
    content: "Combining aesthetics with functionality Creating beautiful and intuitive user interfaces",
    bg: "bg-white",
    img: Ui_d_img
  },
  {
    title: "Frontend Development",
    content: "Building responsive and interactive web applications Creating beautiful and intuitive user interfaces",
    bg: "bg-white",
    img: frontend_dev_img
  },
];

export default function ServicesSection() {
  const cardsRef = useRef([]);
  const stackRef = useRef(null);
  const isMobile = useIsMobile();

  const rotateCards = () => {
    let angle = 0;
    cardsRef.current.forEach((card, index) => {
      if (!card) return;
      if (card.classList.contains("away")) {
        card.style.transform = "translateY(-120vh) rotate(-48deg)";
      } else {
        card.style.transform = `rotate(${angle}deg)`;
        angle = angle - 10;
        card.style.zIndex = cardsRef.current.length - index;
      }
    });
  };

  useEffect(() => {
    if (isMobile) {
      cardsRef.current.forEach((card) => {
        if (card) {
          card.style.transform = "none";
        }
      });
      return;
    }

    rotateCards();

    const onScroll = () => {
      const distance = window.innerHeight * 0.5;
      const topVal = stackRef.current.getBoundingClientRect().top;
      let index = Math.floor(-1 * (topVal / distance + 1));

      cardsRef.current.forEach((card, i) => {
        if (!card) return;
        if (i <= index) {
          card.classList.add("away");
        } else {
          card.classList.remove("away");
        }
      });

      rotateCards();
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [isMobile]);

  return (
    <div
      id="services"
      ref={stackRef}
      className="w-full relative lg:h-[300vh] h-auto bg-white flex flex-col lg:flex-row"
    >
        <div className="container mx-auto flex flex-col lg:flex-row py-24">
      {/* Left Section */}
      <div className="lg:sticky lg:top-0 lg:h-screen flex-1 flex justify-center flex-col px-4 mb-12 lg:mb-0">
      <h5 className='text-primary mb-6 font-Urbanist font-medium tracking-widest text-xl'>Services</h5>
        <h2 className="section-heading font-Urbanist font-light tracking-widest text-4xl lg:text-5xl xl:text-7xl">
        So, What I Bring to the Table?👩‍💻
        </h2>
        <div className="mt-8 max-w-[420px] text-muted-foreground">
          <p>
          I design seamless, user-focused digital experiences that not only look 
          good — they feel right. From wireframes to polished UI, I help brands and 
          teams bring their ideas to life with thoughtful design, strong UX strategy, 
          and a creative eye that cares about the why behind every interaction.
          </p>
        </div>
      </div>

      {/* Right Section */}
      <div
        className={`lg:sticky lg:top-0 lg:h-screen flex-1 relative lg:mt-0 mt-12 ${isMobile ? "overflow-hidden" : ""}`}
      >
        {features.map((item, idx) => (
          <div
            key={idx}
            ref={(el) => (cardsRef.current[idx] = el)}
            className={`w-full lg:w-[600px] h-[400px]  rounded-[25px] transition-transform duration-1000 ease-in-out ${item.bg} box-border border-[1px] p-9 flex flex-row items-center justify-between shadow-lg ${
              isMobile
                ? "mb-8 relative"
                : "lg:left-[5%] lg:top-[20%] lg:-translate-x-1/2 lg:-translate-y-1/2 lg:absolute"
            }`}
          >
            <div 
              className="absolute inset-0 rounded-[25px] bg-cover bg-center bg-no-repeat opacity-20 z-0"
              style={{ backgroundImage: `url(${item.img})` }}
            />
            <div className="relative z-10 w-full h-full flex flex-col lg:flex-row justify-between">
              <div className="w-full lg:flex-1 flex flex-col justify-center lg:items-start items-center text-center lg:text-left">
                <h3 className="text-3xl lg:text-5xl font-medium font-urbanist mb-4 tracking-widest">{item.title}</h3>
                <p className="text-muted-foreground lg:max-w-[80%]">{item.content}</p>
              </div>
              <div className="w-full lg:flex-1 flex justify-center lg:justify-end mt-6 lg:mt-0">
                <div className="bg-cover bg-center bg-no-repeat w-full h-48 lg:h-full" style={{ backgroundImage: `url(${item.img})` }} />
              </div>
            </div>
          </div>
        ))}
      </div>
      </div>
    </div>
  );
};
